module.exports = __webpack_public_path__ + "assets/img/sdwan-module8-1.25701581.jpg";